<template>
  <div class="h-incrementer">
    <div class="left-control">
      <div class="label">{{ $t('components.h_promotion_incrementer.pay') }}</div>
      <div class="control-incrementer">
        <v-btn tabindex="-1" aria-label="-" @click="minusAction" :disabled="disableMinus" icon class="minus-btn">
          <v-icon color="black" size="24px">mdi-minus-circle-outline</v-icon>
        </v-btn>

        <div class="value">{{ pay | currency | currencySymbol }}</div>

        <v-btn tabindex="-1" aria-label="+" @click="plusAction" :disabled="disablePlus" icon class="plus-btn">
          <v-icon color="black" size="24px">mdi-plus-circle-outline</v-icon>
        </v-btn>
      </div>
    </div>

    <div class="middle-control">
      <div class="label">{{ $t('components.h_promotion_incrementer.percentage') }}</div>
      <div class="value">{{ percent_display | bonusSymbol }}</div>
    </div>

    <div class="right-control">
      <div class="label">{{ $t('components.h_promotion_incrementer.obtain') }}</div>
      <div class="value">{{ obtain | currency | currencySymbol }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'h-promotion-incrementer',
  props: {
    defaultPay: {
      type: Number,
    },
    percent: {
      type: Number,
    },
    percent_display: {
      type: String,
    },
    step: {
      type: Number,
    },
    min: {
      type: Number,
    },
    max: {
      type: Number,
    },
  },
  data() {
    return {
      pay: this.defaultPay,
    };
  },
  computed: {
    disableMinus() {
      return this.pay - this.step < this.min;
    },
    disablePlus() {
      return this.pay - this.step >= this.max;
    },
    obtain() {
      return this.pay * (1 + this.percent);
    },
  },
  methods: {
    plusAction() {
      if (this.pay + this.step < this.max) {
        this.pay += this.step;
      }
      // this.$emit('plus');
    },
    minusAction() {
      if (this.pay - this.step >= this.min) {
        this.pay -= this.step;
      }
      // this.$emit('minus');
    },
  },
};
</script>

<style lang="scss" scoped>
.h-incrementer {
  max-width: 100%;
  display: flex;
  flex-wrap: wrap;

  justify-content: space-evenly;
  padding: var(--gap);
  background-color: var(--color-background-alt);
}

.h-incrementer > * {
  min-width: 90px;
  text-align: center;
}

.control-incrementer {
  display: flex;
  align-items: center;
  justify-content: center;
}

.label {
  margin-bottom: 4px;
  font-size: var(--font-size-label-4);
  text-transform: uppercase;
  font-weight: 600;
  text-align: center;
}

.value {
  line-height: 46px;
  color: var(--color-secondary);
}

.plus-btn,
.minus-btn {
  color: var(--color-secondary);
}

.minus-btn {
  margin-left: -10px;
}

.plus-btn {
  margin-right: -10px;
}

@media ($sm-min) {
  .h-incrementer > * {
    min-width: 162px;
    text-align: center;
  }

  .value {
    font-size: var(--font-size-h1);
  }

  .label {
    font-size: var(--font-size-label-3);
  }
}

.minus-btn.v-btn--disabled,
.plus-btn.v-btn--disabled {
  .v-icon {
    opacity: 0.5;
    color: var(--color-secondary) !important;
  }
}
</style>
